(function() {
  'use strict';

  function ComingUpBlock(options) {
    if (!options) {
      throw new Error('No options passed to ComingUpBlock constructor');
    }

    this.options = $.extend({}, ComingUpBlock.defaults, options);

    this.initComingUpBlock();
  }

  ComingUpBlock.prototype.initComingUpBlock = function() {
    let $container = $(this.options.container_selector),
      $mobile_container = $(this.options.mobile_container_selector),
      $template = wp.template(this.options.template_selector),
      data = {};

    if ((!$container.length && !$mobile_container.length) || !$template) {
      return;
    }

    if (typeof this.options.sport_category_slug !== 'undefined' &&
      this.options.sport_category_slug.length) {
      data.sport_category_slug = this.options.sport_category_slug;
    }

    console.log(this.options);

    if (typeof this.options.sport_category_id !== 'undefined' &&
      this.options.sport_category_id) {
      data.sport_category_id = this.options.sport_category_id;
    }

    $.ajax({
      url: '/wp-json/arkansas/v2/load_coming_up_events',
      dataType: 'json',
      cache: true,
      data: data,
      success: function(json) {
        firePageView();
        if (json.length) {
          $.each(json, function(k, v) {
            if ($container.length) {
              $container.append($template(v));
            }

            if ($mobile_container.length && k < 5) {
              $mobile_container.append($template(v));
            }
          });

          if ($container.length) {
            $container.parents('.coming').show();
          }

          if ($mobile_container.length) {
            $mobile_container.parents('.coming').show();
          }
        }

        var sidebarLeft = $('.sidebar-wrap');
        if (sidebarLeft.length) {
          sidebarLeft.trigger('sticky_kit:recalc');
        }
      },
    });
  };

  ComingUpBlock.defaults = {
    container_selector: '#coming_up_list',
    mobile_container_selector: '#coming_up_list_mobile',
    template_selector: 'coming-up-item',
  };

  window.ComingUpBlock = ComingUpBlock;
}())
;
